
import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../HomeComponents/Header";
import Marquee from "../HomeComponents/Marquee";
import VideoSection from "../HomeComponents/VideoSection";
import Services from "../HomeComponents/Services";
import Feedback from "../HomeComponents/Feedback";
import ContactForm from "../HomeComponents/ContactForm";
import StatsCards from "../HomeComponents/StatsCards ";
import FAQs from "../HomeComponents/FAQs";
import ProjectCards from "../HomeComponents/ProjectCards";

export default function Home() {
  useEffect(() => {
    AOS.init({ duration: 2000, once: true });
  }, []);

  const [data, setData] = useState({
    faqs: [],
    home_projects: [],
    home_service: [],
    client_feedback: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [faqs, projects, services, feedback] = await Promise.all([
          fetch("./Database/Home_faqs.json").then(res => res.json()),
          fetch("./Database/Home_projects.json").then(res => res.json()),
          fetch("./Database/Home_service.json").then(res => res.json()),
          fetch("./Database/Feedback_home.json").then(res => res.json()),
        ]);
        setData({ faqs, home_projects: projects, home_service: services, client_feedback: feedback });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="w-full h-full">
      <Header />
      <Marquee />
      <VideoSection />
      <ProjectCards projects={data.home_projects}/>
      <Services services={data.home_service} />
      <StatsCards />
      <Feedback feedbacks={data.client_feedback} />
      <FAQs faqs={data.faqs} />
      <ContactForm />
    </div>
  );
}